module.exports = __webpack_public_path__ + "static/media/heroes-two.3ab31af0.png";